<div class="selector-wrapper">
  <ng-select
    [fixedPlaceholder]="true"
    [(ngModel)]="innerValue"
    (ngModelChange)="onListadoCategoriaChange($event)"
    [items]="listadoCategorias"
    [placeholder]="placeholder"
    [notFoundText]="notFoundText"
    [loading]="loading || creandoTag"
    [addTag]="allowCreate ? addTagFn : false"
    [disabled]="disabled"
    [clearable]="clearable"
    [searchable]="searchable"
    [multiple]="multiple"
    [virtualScroll]="true"
    [trackByFn]="trackByFn"
    [searchFn]="searchFn"
    [dropdownPosition]="'auto'"
    appendTo="body"
    class="custom-ng-select"
    [style.margin]="margin"
  >
    <!-- Ítem seleccionado -->
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <div class="categoria-label">
        @if (item.global) {
          <span
            class="material-icons"
            style="font-size: 14px; vertical-align: middle"
          >
            public
          </span>
        }
        <span class="categoria-nombre">{{ item.nombre }}</span>
        @if (multiple) {
          <button
            type="button"
            class="irx-chip-quitar label-clear"
            (mousedown)="$event.stopPropagation(); $event.preventDefault()"
            (click)="clear(item)"
            tooltip="Quitar"
            aria-label="Quitar"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </ng-template>

    <!-- Ítems del listado desplegable -->
    <ng-template ng-option-tmp let-item="item">
      <div class="categoria-option">
        @if (item.global) {
          <span
            class="material-icons"
            style="font-size: 14px; vertical-align: middle"
          >
            public
          </span>
        }
        <span class="categoria-nombre">{{ item.nombre }}</span>
      </div>
    </ng-template>
  </ng-select>

  @if (showCrearBtn) {
    <div [matTooltip]="tooltipCrearCategoria" matTooltipPosition="above">
      <app-button
        class="crear-btn"
        matType="mat-fab"
        color="primary"
        icon="add"
        [disabled]="disabledCrearBtn"
        (click)="abrirCrearCategoria()"
      ></app-button>
    </div>
  }
</div>
